import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";

import { UserService, AlertService } from "../_services";
import { AppGlobals } from "../app.globals";
import { matchValidator } from "../_helpers/forms/match.validator";

@Component({
    templateUrl: "resetPassword.component.html",
    styleUrls: ["resetPassword.component.css"]
})
export class ResetPasswordComponent implements OnInit {
    resetPasswordForm: UntypedFormGroup;
    hide = true;
    hideConfirm = true;

    constructor(private formBuilder: UntypedFormBuilder, private router: Router, private userService: UserService, private alertService: AlertService, private appGlobals: AppGlobals, private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.appGlobals.pageTitleValue = "Reset Password";

        this.resetPasswordForm = this.formBuilder.group({
            password: ["", [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/)]],
            confirmPassword: ["", [Validators.required, Validators.minLength(8), matchValidator("password", true)]]
        });
    }

    get f() {return this.resetPasswordForm.controls as any;}

    onSubmit(submitBtn: HTMLButtonElement) {
        // stop here if form is invalid
        if (this.resetPasswordForm.invalid) {
            return;
        }

        setTimeout(() => {
            submitBtn.disabled = true;
        }, 0);

        this.userService.resetPassword(this.f.password.value, this.f.confirmPassword.value, this.route.snapshot.queryParamMap.get("reference"))
            .pipe(first())
            .subscribe(() => {
                this.alertService.showMessage("Password reset Successfully.", "Forgot Password", this.appGlobals.alertMessageTypes.success);
                this.router.navigate(["/"]);
            });
    }
}
